export default {"src":"/_next/static/media/peanut.000ade45.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};